interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export default function Loading({ size = 'md', text }: LoadingProps) {
  const sizeClasses = {
    sm: 'w-16 h-16',
    md: 'w-24 h-24',
    lg: 'w-32 h-32',
  };

  return (
    <div data-component-id="src/components/ui/Loading.tsx:14:4" data-component-path="src/components/ui/Loading.tsx" data-component-line="14" data-component-end-line="43" data-component-file="Loading.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20justify-center%20gap-6%22%7D" className="flex flex-col items-center justify-center gap-6">
      <div data-component-id="src/components/ui/Loading.tsx:15:6" data-component-path="src/components/ui/Loading.tsx" data-component-line="15" data-component-end-line="24" data-component-file="Loading.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative ${sizeClasses[size]}`}>
        <img data-component-id="src/components/ui/Loading.tsx:16:8" data-component-path="src/components/ui/Loading.tsx" data-component-line="16" data-component-end-line="23" data-component-file="Loading.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Flogo-ins-akif.png%22%2C%22alt%22%3A%22Ice%20n%20Spice%20Logo%22%2C%22className%22%3A%22w-full%20h-full%20object-contain%20animate-pulse%22%7D"
          src="/logo-ins-akif.png"
          alt="Ice n Spice Logo"
          className="w-full h-full object-contain animate-pulse"
          style={{
            animation: 'logo-shake 2s ease-in-out infinite',
          }}
        />
      </div>
      {text && <p data-component-id="src/components/ui/Loading.tsx:25:15" data-component-path="src/components/ui/Loading.tsx" data-component-line="25" data-component-end-line="25" data-component-file="Loading.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-gray-500%20animate-pulse%22%7D" className="text-sm font-semibold text-gray-500 animate-pulse">{text}</p>}
      <style data-component-id="src/components/ui/Loading.tsx:26:6" data-component-path="src/components/ui/Loading.tsx" data-component-line="26" data-component-end-line="42" data-component-file="Loading.tsx" data-component-name="style" data-component-content="%7B%22elementName%22%3A%22style%22%7D" jsx global>{`
        @keyframes logo-shake {
          0%,
          100% {
            transform: translateY(0) rotate(0deg);
          }
          25% {
            transform: translateY(-10px) rotate(-5deg);
          }
          50% {
            transform: translateY(0) rotate(0deg);
          }
          75% {
            transform: translateY(-10px) rotate(5deg);
          }
        }
      `}</style>
    </div>
  );
}
